import type { TmsInvoiceRow } from '@numeo/types-main-web-app'
import { Badge } from '@/components/ds2'
import { STATUS_GROUP_LABEL } from './format'

// How the Invoices page shows a Ready-tab load that cannot be invoiced now (`ar_status`); any other status reads "Not ready".
const NOT_READY_LABEL: Partial<Record<NonNullable<TmsInvoiceRow['ar_status']>, string>> = { draft: 'Draft', issue: 'Issue' }

/** A row from the Ready tab, which the chat lists one load per item; any other row is an invoice. */
export const isReadyTabRow = (row: TmsInvoiceRow): boolean => row.status_group === 'ready_to_invoice' || row.readiness !== undefined

/**
 * A row's status: a Ready-tab row says whether it can be invoiced now, by its readiness, else its page status; an invoice row its
 * Invoices page group. A Ready-tab row is never labelled by its tab ("Ready to invoice"): the tab holds loads that are not ready too.
 */
export const StatusBadge = ({ row }: { row: TmsInvoiceRow }) => {
    const ready = row.readiness ? row.readiness === 'ready' : row.ar_status === 'ready'
    if (row.status_group !== 'ready_to_invoice' && !row.readiness) return <span>{STATUS_GROUP_LABEL[row.status_group] ?? row.status_group}</span>
    if (ready) return <Badge variant="soft" type="success" size="sm" label="Ready" />
    if (row.readiness === 'not_ready' || row.ar_status) {
        return <Badge variant="soft" type="warning" size="sm" label={(row.ar_status && NOT_READY_LABEL[row.ar_status]) ?? 'Not ready'} />
    }
    return <span>Not invoiced</span>
}
